import { PriceZoneGroupModelType } from '@teinor/erp/types/company/priceZone/priceZoneGroup'
import { useLocation, useParams } from 'react-router-dom'
import ModalCEPriceZone from './ModalCEPriceZone'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import SinglePriceZone from './SinglePriceZone'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { getBasePath } from '../../../../../../utils/globals/link'

interface PriceZonesProps extends ComponentWithPermissions { }

const PriceZones: React.FC<PriceZonesProps> = ({ userPermissions }) => {
    const { PriceZoneGroupId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={PriceZonesInner} SecondChild={SinglePriceZone} displaySecond={PriceZoneGroupId !== 'main'} />)
}

interface PriceZonesInnerProps extends ComponentWithPermissions { }

const PriceZonesInner: React.FC<PriceZonesInnerProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('priceZoneGroups', 'Grupos de zonas de precios'),
        newText: t('createNewGroup', 'Crear nuevo grupo')
    }

    return (
        <BaseScreenTable TableComponent={PriceZonesTable} CreateModalComponent={ModalCEPriceZone} EditModalComponent={ModalCEPriceZone} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface PriceZonesTableProps extends TableComponentProps { }

const PriceZonesTable: React.FC<PriceZonesTableProps> = ({ setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'priceZones')
    const { PriceZoneGroupId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(PriceZoneGroupId || '')
    const columns: ColumnTableSchema<PriceZoneGroupModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        }
    ]
    return (
        <TwinTableLink columns={columns} getDataFrom='/api/app/product/priceZoneGroup/getAllPriceZoneGroups' name='priceZoneGroups' rowRenderer={rowRenderer} createRowDataLink={[basePath, ['$id']]} setTableInstance={setTableInstance} hideLoadFiltersButton={true} />
    )
}


export default PriceZones